export default (title, bodyHtml) => {
    // NOTE: do NOT pass `noopener` / `noreferrer` here — `window.open` returns null
    // when noopener is set, so we'd lose the handle and the new tab stays blank.
    // We write first-party HTML into the window below, so the reference is required.
    const w = window.open('', '_blank', 'width=900,height=1000');
    if (!w) return;

    const css = `
        @page { margin: 18mm 16mm; }
        html, body { background: #fff !important; color: #111; }
        body {
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
            font-size: 12pt; line-height: 1.55; margin: 0; padding: 24px;
        }
        header.print-header {
            display: flex; align-items: center; gap: 10px;
            border-bottom: 1px solid #ddd; padding-bottom: 8px; margin-bottom: 16px;
        }
        header.print-header h1 { font-size: 16pt; margin: 0; font-weight: 600; }
        .print-badge {
            display: inline-block; padding: 2px 8px; border: 1px solid #cbd5e1;
            border-radius: 999px; font-size: 10pt; color: #334155; background: #f1f5f9;
        }
        .ra-markdown h1 { font-size: 15pt; margin-top: 18px; }
        .ra-markdown h2 { font-size: 13.5pt; margin-top: 14px; }
        .ra-markdown h3 { font-size: 12.5pt; margin-top: 12px; }
        .ra-markdown p, .ra-markdown li { margin: 6px 0; }
        .ra-markdown ul, .ra-markdown ol { padding-left: 22px; }
        .ra-markdown table { border-collapse: collapse; width: 100%; margin: 10px 0; }
        .ra-markdown th, .ra-markdown td { border: 1px solid #d1d5db; padding: 6px 8px; text-align: left; }
        .ra-markdown code, .ra-markdown pre {
            font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 10.5pt;
            background: #f8fafc; border-radius: 3px;
        }
        .ra-markdown pre { padding: 8px; overflow: auto; page-break-inside: avoid; }
        details.ai-list-dropdown summary { display: none; }
        details.ai-list-dropdown { display: block; }
        a { color: #111; text-decoration: underline; }
    `;

    w.document.open();
    w.document.write(`<!doctype html>
<html><head>
<meta charset="utf-8"/>
<title>${title}</title>
<style>${css}</style>
</head><body>
${bodyHtml}
<script>
    (function () {
        function go() { try { window.focus(); window.print(); } catch (e) {} }
        if (document.readyState === 'complete') setTimeout(go, 150);
        else window.addEventListener('load', () => setTimeout(go, 150));
    })();
<\/script>
</body></html>`);
    w.document.close();
};
